import styled from 'styled-components'


export const SC_AppContainer = styled.div`
  position: relative;
  width: 100%;
  scrollbar-width: none;
  max-width: 520px;
  margin: 0 auto;
  min-height: 100dvh;
  box-sizing: border-box;
`

export const SC_AppWrapper = styled.div.attrs(() => ({
  id: 'app-wrapper',
}))`
  height: 100dvh;
  padding: calc(60px + env(safe-area-inset-top, 0px)) 0 0;
  box-sizing: border-box;
  overflow-y: auto;
  scrollbar-width: none;
  margin: 0 auto;
  max-width: 520px;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`
